import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { openModal } from '../actions/modal-actions';

const useOpenModal = () => {
  const dispatch = useDispatch();
  return useCallback((...args) => dispatch(openModal(...args)), [dispatch]);
};

export default useOpenModal;
